module.exports = __webpack_public_path__ + "static/liva-pastacilik-case-study-4-116114577336d0c15d77a10641739d23.png";